import { useState } from "react";
import { FileDown, SlidersHorizontal } from "lucide-react";
import { downloadUrl } from "../../lib/api";
import LocTemplateDialog from "./LocTemplateDialog";

const A = "inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border text-xs font-semibold bg-white";
const STANDARD = (pid) => [
  ["loc-template-subeler", "Şubeler", `/locations/template-custom?project_id=${pid}&preset=subeler`, "Bölge · Şube Kodu · Şube Adı · İl · İlçe · SGK / e-Bildirge · Şube Türü · m² dağılımı · Kat · Taşeron · hizmet fiyatları"],
  ["loc-template-taseron", "Taşeronlar ve Taşeron Fiyatları", `/locations/template-custom?project_id=${pid}&preset=taseron`, "Bölge · Şube Kodu · Şube Adı · İl · İlçe · Taşeron (fatura kesen) · Taşeron kullanıcısı (işi yapan) · hizmet başına taşeron fiyatı"],
];

// Standart şablon indirme + "Kendi Şablonunu Oluştur" (Şubeler ve Hizmetler sekmelerinde ortak)
export default function LocTemplateTools({ projectId, testidSuffix = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-1.5" data-testid={`loc-tools-templates${testidSuffix}`}>
      <div className="text-[10px] font-bold uppercase tracking-wider text-emerald-800">Standart Şablonlar</div>
      <div className="flex flex-wrap gap-1.5">
        {STANDARD(projectId).map(([tid, label, path, title]) => <a key={tid} href={downloadUrl(path)} target="_blank" rel="noreferrer" data-testid={`${tid}${testidSuffix}`} title={title} className={`${A} border-emerald-700 text-emerald-800 hover:bg-emerald-50`}><FileDown className="w-3.5 h-3.5" /> {label}</a>)}
      </div>
      <button type="button" onClick={() => setOpen(true)} data-testid={`loc-template-custom${testidSuffix}`} title="Proje kartındaki tüm alanları tek tek ya da toplu seçerek kendi şablonunuzu oluşturun" className={`${A} border-slate-800 text-slate-900 hover:bg-slate-50`}><SlidersHorizontal className="w-3.5 h-3.5" /> Kendi Şablonunu Oluştur</button>
      <LocTemplateDialog open={open} onClose={() => setOpen(false)} projectId={projectId} />
    </div>
  );
}
